type CartLocationState = { idealPaymentFailed?: boolean } | null;

/**
 * Marks an iDEAL return URL that started from the cart; paying an existing
 * order comes back to the same order page and must stay there.
 */
export const IDEAL_FROM_CART_PARAM = "fromCart";

/** Router state the order page hands the cart after a failed iDEAL payment. */
export const IDEAL_PAYMENT_FAILED_STATE: CartLocationState = {
  idealPaymentFailed: true,
};

export const isIdealPaymentFailedState = (state: unknown): boolean =>
  (state as CartLocationState)?.idealPaymentFailed === true;
